/**
 * getQuestionnaireAnswerFacetCount
 * @description Utility function to get a questionnaire answer facet count
 * If the result is `null`, it means either:
 * - the `questionnaireAnswerFacets` is loading
 * - the `questionnaireAnswerFacets` has errors
 *
 */
export const getQuestionnaireAnswerFacetCount = ({
  answerId,
  questionnaireAnswerFacets,
}: {
  answerId: string;
  questionnaireAnswerFacets: Record<
    string,
    { id: string; count: number }
  > | null;
}): number | null => {
  if (!questionnaireAnswerFacets) {
    return null;
  }

  const facet = questionnaireAnswerFacets[answerId];
  // If there's no facet for an answer, it means no candidate has chosen it
  if (!facet) {
    return 0;
  }

  return facet.count;
};
